import { transformMovementList } from '@/common/integrations/menhir/employee/movements/movements.dto';
import { IGetMenhirMovementsDataEnvelope } from '@/common/integrations/menhir/employee/movements/movements.types';
import { menhirClient } from '@/common/integrations/menhir/menhir.client';
import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import { IGetMovementsParams } from './movements.types';

export const getMovementsData = ({
  pocketId,
  pocketIds,
  category,
  subcategory,
  page,
  perPage,
  pagination,
  subcategory_not_in,
  subcategory_in,
  from,
  to,
}: IGetMovementsParams) =>
  menhirClient
    .get<null, IGetMenhirMovementsDataEnvelope>(
      MENHIR_ENDPOINTS.EMPLOYEE.MOVEMENTS,
      {
        params: {
          pocket_id: pocketId,
          'filters[pockets_in]': pocketIds,
          category: category,
          'filters[subcategory]': subcategory,
          'filters[subcategory_not_in]': subcategory_not_in,
          'filters[subcategory_in]': subcategory_in,
          'filters[movement_from]': from,
          'filters[movement_to]': to,
          page: page,
          per_page: perPage,
          pagination,
        },
      }
    )
    .then((envelope) => transformMovementList(envelope));
